import React from 'react';
import PropTypes from 'prop-types';
import { SFUpcomingAppt, SFNotification, SFEntityID } from 'utils/types';
import css from 'serviceCatalog/connectionProfile/ConnectionView.scss';
import ConnectionPlaceholder from 'serviceCatalog/connectionProfile/ConnectionPlaceholder';
import EditAppointment from './EditAppointment';
import ScrollToTopOnMount from 'common/ScrollToTopOnMount';
import ConnectionHeader from 'serviceCatalog/connectionProfile/ConnectionHeader';

export default class EditAppointmentView extends React.Component {

  get content() {
    if ( !this.props.hasFetched ) return <ConnectionPlaceholder />;
    if ( this.props.appointment === null ) return null;
    return (
      <EditAppointment
        timeZone={this.props.timeZone}
        appointment={this.props.appointment}
        partyId={this.props.partyId}
        notification={this.props.notification}
        header={(
          <ConnectionHeader
            officeHours={this.props.appointment.owner.officeHours}
            personId={this.props.appointment.owner.id}
            uuid={this.props.appointment.owner.uuid}
            fullName={this.props.appointment.owner.name}
            roles={this.props.appointment.owner.roles}
            title={this.props.appointment.owner.title}
            photoAvailable={this.props.appointment.owner.photoAvailable}
          />
        )}
      />
    );
  }

  render() {
    return (
      <div className={css['container']}>
        <ScrollToTopOnMount />
        {this.content}
      </div>
    );
  }
}

EditAppointmentView.propTypes = {
  appointment: PropTypes.shape(SFUpcomingAppt),
  partyId: SFEntityID.isRequired,
  hasFetched: PropTypes.bool.isRequired,
  notification: SFNotification.isRequired,
  timeZone: PropTypes.string.isRequired
};
